import { lazy } from "react";

/* ================= Auth Screens ===============*/
export const SignIn = lazy(() => import("../pages/Auth/SignIn"));
export const Register = lazy(() => import("../pages/Auth/Register"));
export const ForgetPassword = lazy(() => import("../pages/Auth/ForgetPassword"));
export const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));

/* ================= Reporting ================= */
export const ItemsIndemandledger = lazy(() => import("../pages/reporting/ItemsIndemandledger"));
export const Dailysalesledger = lazy(() => import("../pages/reporting/Dailysalesledger"));
export const Customerwisesalesledger = lazy(() => import("../pages/reporting/Customerwisesalesledger"));
export const VehicleWisePartsSalesLedger = lazy(() => import("../pages/reporting/VehicleWisePartsSalesLedger"));
export const ItemWiseSalesLedger = lazy(() => import("../pages/reporting/ItemWiseSalesLedger"));
export const FastMovingItems = lazy(() => import("../pages/reporting/FastMovingItems"));
export const DealersRegionSummary = lazy(() => import("../pages/reporting/DealersRegion"));
export const DealersSalesJourney = lazy(() => import("../pages/reporting/SalesJourney"));
export const CrmRevenueReport = lazy(() => import("../pages/reporting/CrmRevenueReport"));
export const JobCardCompletionReport = lazy(() => import("../pages/reporting/JobCardCompletionReport"));
export const TechnicianEfficiencyReport = lazy(() => import("../pages/reporting/TechnicianEfficiencyReport"));
export const TechnicianJobBreakdownReport = lazy(() => import("../pages/reporting/TechnicianJobBreakdownReport"));
export const PartsCounterSaleReport = lazy(() => import("../pages/reporting/PartsCounterSaleReport"));
export const PartsWorkshopSaleReport = lazy(() => import("../pages/reporting/PartsWorkshopSaleReport"));
export const DailyJobCardCounterReport = lazy(() => import("../pages/reporting/DailyJobCardCounterReport"));
export const SaleReporting = lazy(() => import("../pages/reporting/SaleReporting"));
export const SaleSummary = lazy(() => import("../pages/reporting/SaleSummary"));
export const LowStockReport = lazy(() => import("../pages/reporting/LowStockReport"));

/* ================= Dashboard ================= */
export const DistributorDashboard = lazy(() => import("../pages/dashboard/DistributorDashboard"));
export const PreSalesDashboard = lazy(()=> import("../pages/dashboard/PreSalesDashboard"));
export const PartsDashboard = lazy(()=> import("../pages/dashboard/PartsDashboard"));
export const ServiceDashboard = lazy(()=> import("../pages/dashboard/ServiceDashboard"));

/* ================= Setup Screens ================= */
export const Technician = lazy(() => import("../pages/setup/Technician"));
export const Bank = lazy(() => import("../pages/setup/Bank"));
export const City = lazy(() => import("../pages/setup/City"));
export const Color = lazy(() => import("../pages/setup/Color"));
export const Company = lazy(() => import("../pages/setup/Company"));
export const Customer = lazy(() => import("../pages/setup/CustomerProfile"));
export const Dealer = lazy(() => import("../pages/setup/Dealer"));
export const User = lazy(() => import("../pages/setup/User"));
export const UserRoles = lazy(() => import("../pages/setup/UserRoles"));
export const Stock = lazy(() => import("../pages/setup/Stock"));
export const Quota = lazy(() => import("../pages/setup/Quota"));
export const CorporateClient = lazy(() => import("../pages/setup/CorporateClients"));
export const WorkerShifts = lazy(() => import("../pages/setup/WorkerShifts"));
export const WorkerTypes = lazy(() => import("../pages/setup/WorkerTypes"));
export const WorkerTeams = lazy(() => import("../pages/setup/WorkerTeams"));
export const Skills = lazy(() => import("../pages/setup/Skills"));
export const Transporter = lazy(() => import("../pages/setup/Transporter"));
export const Customers = lazy(() => import("../pages/setup/Customers"));
export const JobCategories = lazy(() => import("../pages/setup/JobCategories"));
export const InsuranceCompanies = lazy(() => import("../pages/setup/InsuranceCompanies"));
export const Vendor = lazy(() => import("../pages/setup/Vendor"));
export const Tax = lazy(() => import("../pages/setup/Tax"));
export const Department = lazy(() => import("../pages/setup/Department"));
export const Source = lazy(() => import("../pages/setup/Source"));
export const Item = lazy(() => import("../pages/setup/vehicle/Item"));
export const CustomerProfile = lazy(() => import("../pages/setup/CustomerProfile"));
export const Discount = lazy(() => import("../pages/discount/Discount"));
export const DiscountList = lazy(() => import("../pages/discount/DiscountList"));
export const DealerQouta = lazy(() => import(("../pages/qouta/DealerQouta")));
export const DistributorQouta = lazy(() => import("../pages/qouta/DistributorQouta"));

/* ================= Finance ================= */
export const Financial = lazy(() => import("../pages/finance/Financial"));
export const COAconfig = lazy(() => import("../pages/setup/finance/COAconfig"));
// Finance – General Ledger
export const GlChartOfAccounts = lazy(() => import("../pages/finance/gl/ChartOfAccounts"));
export const GlJournalVouchers = lazy(() => import("../pages/finance/gl/JournalVouchers"));
export const GlAccountLedger = lazy(() => import("../pages/finance/gl/AccountLedger"));
export const GlTrialBalance = lazy(() => import("../pages/finance/gl/TrialBalance"));
export const GlProfitLoss = lazy(() => import("../pages/finance/gl/ProfitLoss"));
export const GlBalanceSheet = lazy(() => import("../pages/finance/gl/BalanceSheet"));
export const GlCashFlow = lazy(() => import("../pages/finance/gl/CashFlow"));
export const GlFinanceIntegration = lazy(() => import("../pages/finance/gl/FinanceIntegration"));
export const GlPartnerBalances = lazy(() => import("../pages/finance/gl/PartnerBalances"));
export const GlDepositSlips = lazy(() => import("../pages/finance/gl/DepositSlips"));
export const GlWorkshopPayments = lazy(() => import("../pages/finance/gl/WorkshopPayments"));
export const GlVehicleSaleStatement = lazy(() => import("../pages/finance/gl/VehicleSaleStatement"));
export const GlWorkshopLedger = lazy(() => import("../pages/finance/gl/WorkshopLedger"));
export const GlPartReturnRefunds = lazy(() => import("../pages/finance/gl/PartReturnRefunds"));
export const CodeConfig = lazy(() => import("../pages/setup/finance/CodeConfig"));
export const CustomerLedger = lazy(() => import("../pages/finance/CustomerLedger"));
export const CompanyLedger = lazy(() => import("../pages/finance/CompanyLedger"));
export const VendorPayments = lazy(() => import("../pages/finance/VendorPayments"));
export const CustomerPayments = lazy(() => import("../pages/finance/CustomerPayments"));

/* ================= Parts Setup ================= */
export const Category = lazy(() => import("../pages/setup/parts/Category"));
export const Parts = lazy(() => import("../pages/setup/parts/Parts"));
export const Make = lazy(() => import("../pages/setup/parts/Make"));
export const Model = lazy(() => import("../pages/setup/parts/Model"));
export const Variant = lazy(() => import("../pages/setup/parts/Variant"));
export const ColorsParts = lazy(() => import("../pages/setup/parts/ColorsParts"));
export const PartsBinning = lazy(() => import("../pages/inventory/PartsBinningConfig"));

/* ================= Vehicle Setup ================= */
export const VehicleVariant = lazy(() => import("../pages/setup/vehicle/VehicleVariant"));

/* ================= Auth Setup ================= */
export const Privileges = lazy(() => import("../pages/setup/Auth/Privileges"));
export const RolesSetup = lazy(() => import("../pages/setup/Auth/RolesSetup"));
export const UsersSetup = lazy(() => import("../pages/setup/Auth/UsersSetup"));
export const Module = lazy(() => import("../pages/setup/Auth/Module"));
export const Screen = lazy(() => import("../pages/setup/Auth/Screen"));
export const SubScreens = lazy(() => import("../pages/setup/Auth/SubScreens"));
export const RolesPrivileges = lazy(() => import("../pages/setup/Auth/RolesPrivileges"));
export const MasterSetupScreen = lazy(() => import("../pages/setup/Auth/MasterSetupScreen"));

/* ================= Pre Sales ================= */
export const Lead = lazy(() => import("../pages/preSales/Lead"));
export const Opportunity = lazy(() => import("../pages/preSales/Opportunity"));


export const Quotation = lazy(() => import("../pages/preSales/Quotation"));
export const TestDrive = lazy(() => import("../pages/preSales/TestDrive"));
export const Visiting = lazy(() => import("../pages/preSales/Visiting"));
export const QuotationDetails = lazy(() => import("../pages/preSales/QuotationDetails"));
export const LeadDetails = lazy(() => import("../pages/preSales/LeadDetails"));

/* ================= PBO ================= */
export const PBOadd = lazy(() => import("./../pages/pbo/PBOadd"));
export const PBOdetails = lazy(() => import("../pages/pbo/PBOdetails"));
export const PBOinquiries = lazy(() => import("../pages/pbo/PBOinquiries"));
export const CustomerTransactions = lazy(() => import("../pages/pbo/CustomerTransactions"));
export const SalesFilesUpload = lazy(() => import("../pages/pbo/SalesFilesUpload"));
export const SalesInquiries = lazy(() => import("../pages/pbo/SalesInquiries"));
export const Payments = lazy(() => import("../pages/pbo/Payments"));
export const PaymentsOE = lazy(() => import("../pages/reporting/PaymentsOE"));
export const CancelandChangeSaleRequest = lazy(() => import("../pages/pbo/CancelandChangeSaleRequest"));
export const CancelledSales = lazy(() => import("../pages/pbo/CancelledSales"));
export const InvoiceRequest = lazy(() => import("../pages/pbo/InvoiceRequest"));
export const Test = lazy(() => import("../pages/pbo/test"));
export const InvoiceOrder = lazy(() => import("../pages/pbo/InvoiceOrder"));

/* ================= Quota Request ================= */
export const QuotaRequest = lazy(() => import("../pages/setup/QuotaRequest"));
export const SalesmanQouta = lazy(() => import("../pages/qouta/SalesmanQouta"));

/* ================= After Sales ================= */
export const AddCrmAppointment = lazy(() => import("../pages/afterSales/AddCrmAppointment"));
export const AddVehicle = lazy(() => import("../pages/afterSales/AddVehicle"));
export const CrmAppointments = lazy(() => import("../pages/afterSales/CrmAppointments"));
export const DqirInquiries = lazy(() => import("../pages/afterSales/DqirInquiries"));
export const EstimatesInquiries = lazy(() => import("../pages/afterSales/EstimatesInquiries"));
export const InvoiceInquirires = lazy(() => import("../pages/afterSales/InvoiceInquirires"));
export const PartsRequisitionInquiries = lazy(() => import("../pages/afterSales/PartsRequisitionInquiries"));
export const PurchaseOrderInquiries = lazy(() => import("../pages/afterSales/PurchaseOrderInquiries"));
export const WarrantyInquiries = lazy(() => import("../pages/afterSales/WarrantyInquiries"));
export const VehicleServiceHistory = lazy(() => import("../pages/afterSales/VehicleServiceHistory"));
export const JobCard = lazy(() => import("../pages/afterSales/JobCard"));
export const JobCardInquiries = lazy(() => import("../pages/afterSales/JobCardInquiries"));
export const JobCardDetail = lazy(() => import("../pages/afterSales/JobCardDetail"));
export const PdsRequests = lazy(() => import("../pages/afterSales/PdsRequests"));
export const PreSalesPerformanceReport = lazy(() => import("../pages/reporting/PreSalesPerformanceReport"));
export const JobCardInspectionDetail = lazy(() => import("../pages/afterSales/JobCardInspectionsDetails"));
export const JobCardEstimation = lazy(() => import("../pages/afterSales/JobCardEstimation"));
export const JobCardInspections = lazy(() => import("../pages/afterSales/JobCardInspection"));
export const AddPurchaseOrder = lazy(() => import("../pages/afterSales/AddPurchaseOrder"));
export const AddPartsCounterSale = lazy(() => import("../pages/afterSales/AddPartsCounterSale"));
export const CustomersList = lazy(() => import("../pages/afterSales/CustomersList"));
export const PostServiceFollowUp = lazy(() => import("../pages/afterSales/PostServiceFollowUp"));
export const AppointmentReconfirmation = lazy(() => import("../pages/afterSales/AppointmentReconfirmation"));
export const MrsReminders = lazy(() => import("../pages/crm/MrsReminders"));
export const StockMovement = lazy(() => import("../pages/afterSales/StockMovement"));
export const VehicleMasterList = lazy(() => import("../pages/afterSales/VehicleMasterList"));
export const Workshop = lazy(() => import("../pages/afterSales/WorkshopLoading"));
export const WorkshopView = lazy(() => import("../pages/afterSales/WorkshopView"));
export const YearCalender = lazy(() => import("../pages/afterSales/YearCalender"));
export const WorkshopHoliday = lazy(() =>import("../pages/setup/WorkshopHoliday"));
export const DQIRForm = lazy(() => import("../pages/afterSales/DQIRForm"));
export const DQIRList = lazy(() => import("../pages/afterSales/DQIRList"));
export const DQIRRevenue = lazy(() => import("../pages/afterSales/DQIRRevenue"));
export const DQIRDetails = lazy(() => import("../pages/afterSales/DQIRDetails"));

/* ================= Inventory ================= */
export const StockCheckAndAdj = lazy(() => import("../pages/inventory/StockCheckAndAdj"));
export const PartsStockAdjustment = lazy(() => import("../pages/inventory/PartStockAdjustment"));
export const PurchaseOrder = lazy(() => import("../pages/inventory/PurchaseOrder"));
// export const PurchaseItem = lazy(() => import("../pages/inventory/PurchaseItem"));
export const PurchaseReturnList = lazy(() => import("../pages/inventory/PurchaseReturnList"));
export const PurchaseOrderList = lazy(() => import("../pages/inventory/PurchaseOrderList"));
export const PurchaseGoodsReceiving = lazy(() => import("../pages/inventory/PurchaseGoodsReceiving"));
export const PurchaseGoodsReceivingList = lazy(() => import("../pages/inventory/PurchaseGoodsReceivingList"));
export const SaleDeliveryNote = lazy(() => import("../pages/inventory/SaleDeliveryNote"));
export const PurchaseOrderDetail = lazy(() => import("../pages/inventory/PurchaseOrderDetail"));
export const PurchaseReturnExchange = lazy(() => import("../pages/inventory/PurchaseReturn"));
export const PartsIssue = lazy(() => import("../pages/inventory/PartsIssue"));
export const SaleItem = lazy(() => import("../pages/inventory/SaleItem"));
export const SaleDeliveryNoteList = lazy(() => import("../pages/inventory/SaleDeliveryNoteList"));
export const SaleOrderList = lazy(() => import("../pages/inventory/SaleOrderList"));
export const SaleOrderDetail = lazy(() => import("../pages/inventory/SaleOrderDetail"));
export const PartsStock = lazy(() => import("../pages/inventory/PartsStock"));
export const SaleReturnExchange = lazy(() => import("../pages/inventory/SaleReturnExchange"));
export const SaleReturnList = lazy(() => import("../pages/inventory/SaleReturnList"));
export const PurchaseRequest = lazy(() => import("../pages/inventory/PurchaseRequest"));
export const PurchaseInvoice = lazy(() => import("../pages/inventory/PurchaseInvoice"));
export const PurchaseInvoiceList = lazy(() => import("../pages/inventory/PurchaseInvoiceList"));
export const PurchaseInvoiceDetail = lazy(() => import("../pages/inventory/PurchaseInvoiceDetail"));
export const PartsDemand = lazy(() => import("../pages/inventory/PartsDemand"));
//
export const PartsBackOrder = lazy(() => import("../pages/inventory/PartsBackOrder"));
// export const PartsBackOrderList = lazy(() => import("../pages/inventory/PartsBackOrderList"));
export const PartsDamaged = lazy(() => import("../pages/inventory/PartsDamaged"));
// export const PartsDamagedList = lazy(() => import("../pages/inventory/PartsDamagedList"));
export const PartsReserved = lazy(() => import("../pages/inventory/PartsReserved"));
// export const PartsReservedList = lazy(() => import("../pages/inventory/PartsReservedList"));
export const PartsWarranty = lazy(() => import("../pages/inventory/PartsWarranty"));
// export const PartsWarrantyList = lazy(() => import("../pages/inventory/PartsWarrantyList"));


/* ================== CRM =================== */
export const CrmInquiry = lazy(() => import("../pages/crm/CrmInquiry"));
export const CrmInquiryDetails = lazy(() => import("../pages/crm/CrmInquiryDetails"));
export const CrmComplaint = lazy(() => import("../pages/crm/CrmComplaint"));
export const CrmComplaintDetails = lazy(() => import("../pages/crm/CrmComplaintDetails"));
export const CustomerJourney = lazy(() => import("../pages/customerJourney/CustomerJourney"));
export const CrmComplaintSetup = lazy(() => import("../pages/crm/CrmComplaintSetup"));

/* ============== HR & Payroll ============== */
export const HRDashboard = lazy(() => import("../pages/hr/HRDashboard"));
export const HrEmployeeList = lazy(() => import("../pages/hr/employees/EmployeeList"));
export const HrEmployeeProfile = lazy(() => import("../pages/hr/employees/EmployeeProfile"));
export const HrDailyAttendance = lazy(() => import("../pages/hr/attendance/DailyAttendance"));
export const HrAttendanceImport = lazy(() => import("../pages/hr/attendance/AttendanceImport"));
export const HrMonthlyAttendance = lazy(() => import("../pages/hr/attendance/MonthlyAttendance"));
export const HrLeaveRequests = lazy(() => import("../pages/hr/leave/LeaveRequests"));
export const HrLeaveBalances = lazy(() => import("../pages/hr/leave/LeaveBalances"));
export const HrSalaryStructure = lazy(() => import("../pages/hr/payroll/SalaryStructure"));
export const HrLoans = lazy(() => import("../pages/hr/payroll/Loans"));
export const HrIncentives = lazy(() => import("../pages/hr/payroll/Incentives"));
export const HrPayrollRuns = lazy(() => import("../pages/hr/payroll/PayrollRuns"));
export const HrPayrollRunDetail = lazy(() => import("../pages/hr/payroll/PayrollRunDetail"));
export const HrPayslips = lazy(() => import("../pages/hr/payroll/Payslips"));
export const HrFinalSettlement = lazy(() => import("../pages/hr/payroll/FinalSettlement"));
export const HrReports = lazy(() => import("../pages/hr/reports/HrReports"));
export const HrDesignations = lazy(() => import("../pages/hr/setup/Designations"));
export const HrGrades = lazy(() => import("../pages/hr/setup/Grades"));
export const HrLeaveTypes = lazy(() => import("../pages/hr/setup/LeaveTypes"));
export const HrPayComponents = lazy(() => import("../pages/hr/setup/PayComponents"));
export const HrTaxSlabs = lazy(() => import("../pages/hr/setup/TaxSlabs"));
export const HrPayrollSettings = lazy(() => import("../pages/hr/setup/PayrollSettings"));

/* ================= Errors ================= */
export const Error404 = lazy(() => import("../pages/extra/error404"));
export const Error500 = lazy(() => import("../pages/extra/error500"));



// Dashboard-KPI reports — all configs live in one module
const kpiReport = (name) => lazy(() => import("../pages/reporting/kpi/KpiReports").then((m) => ({ default: m[name] })));
export const PartsTargetVsInvoiceReport = kpiReport("PartsTargetVsInvoiceReport");
export const AppointmentsVsVisitorsReport = kpiReport("AppointmentsVsVisitorsReport");
export const WorkshopRevenueReport = kpiReport("WorkshopRevenueReport");
export const DealerVehicleTargetVsActualReport = kpiReport("DealerVehicleTargetVsActualReport");
export const ModelWiseBookingReport = kpiReport("ModelWiseBookingReport");
export const CustomerComplaintsReport = kpiReport("CustomerComplaintsReport");
export const JobCardsCashVsCreditReport = kpiReport("JobCardsCashVsCreditReport");
export const PartsRequestsReport = kpiReport("PartsRequestsReport");
